import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from './firebase';

/**
 * Menti Participant Service
 * Join sessions and submit responses
 */

export const joinMentiSession = async (sessionId, playerName) => {
  try {
    if (!sessionId || !/^[0-9]{6}$/.test(sessionId.trim())) {
      throw new Error('Ugyldig PIN-kode');
    }

    if (!playerName || typeof playerName !== 'string') {
      throw new Error('Namn er påkravd');
    }
    const trimmedName = playerName.trim();
    if (trimmedName.length < 2 || trimmedName.length > 30) {
      throw new Error('Namn må vere mellom 2 og 30 teikn');
    }

    const ref = doc(db, 'mentiSessions', sessionId);
    const snap = await getDoc(ref);

    if (!snap.exists()) {
      throw new Error('Fann ikkje Menti-økta. Sjekk PIN-koden.');
    }

    const data = snap.data();
    if (data.status === 'finished') {
      throw new Error('Denne Menti-økta er allereie avslutta');
    }

    const participantId = `p${Date.now()}_${Math.random().toString(36).substring(2, 8)}`;

    await updateDoc(ref, {
      [`participants.${participantId}`]: {
        id: participantId,
        name: trimmedName,
        joinedAt: new Date().toISOString()
      }
    });

    return { id: participantId, name: trimmedName };
  } catch (error) {
    console.error('Error joining menti session:', error);
    throw new Error(`Klarte ikkje bli med i Menti-økt: ${error.message}`);
  }
};

export const submitResponse = async (sessionId, participantId, slideId, value) => {
  try {
    if (!sessionId || !participantId || !slideId) {
      throw new Error('Manglar påkravde parametrar');
    }

    const ref = doc(db, 'mentiSessions', sessionId);
    const snap = await getDoc(ref);

    if (!snap.exists()) throw new Error('Fann ikkje Menti-økta');

    const data = snap.data();
    if (data.status !== 'active') {
      throw new Error('Menti-økta er ikkje aktiv');
    }

    if (!data.participants?.[participantId]) {
      throw new Error('Fann ikkje deltakaren i økta');
    }

    // Check if already submitted for this slide
    if (data.responses?.[slideId]?.[participantId]) {
      throw new Error('Du har allereie svart på dette lysbilete');
    }

    await updateDoc(ref, {
      [`responses.${slideId}.${participantId}`]: {
        value,
        submittedAt: new Date().toISOString()
      }
    });
  } catch (error) {
    console.error('Error submitting response:', error);
    throw new Error(`Klarte ikkje sende svar: ${error.message}`);
  }
};
